import NewsletterInput from './NewsletterInput';

export default NewsletterInput;